import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/',
    owner: '/',
    redirect: `/home?t=${new Date().getTime()}`
  },
  {
    exact: true,
    path: '/chosite',
    owner: '/',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  }
];